import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import isBetween from 'dayjs/plugin/isBetween';

dayjs.extend(isBetween);
dayjs.extend(duration);
dayjs.extend(relativeTime);

//TODO Followup Type Properly
const filterNotifsByDate = (notifications: any) => {
  const todayAtMidnight = dayjs().startOf('day');
  const yesterdayAtMidnight = dayjs().subtract(1, 'day').startOf('day');
  const thisWeek = dayjs().startOf('week');
  const lastWeekAtMidnight = dayjs().startOf('week').subtract(1, 'week');
  const thisMonth = dayjs().startOf('month');
  const lastMonth = dayjs().startOf('month').subtract(1, 'month');

  const notifsCategorizedByRelativeDate: { [key: string]: any[] } = {
    Today: [],
    Yesterday: [],
    'This Week': [],
    'Last Week': [],
    'This Month': [],
    'Last Month': [],
  };

  notifications?.forEach((notif: any) => {
    const date = dayjs(notif.createdAt);
    if (date.isAfter(todayAtMidnight)) {
      notifsCategorizedByRelativeDate.Today.push(notif);
    } else if (date.isAfter(yesterdayAtMidnight)) {
      notifsCategorizedByRelativeDate.Yesterday.push(notif);
    } else if (date.isBetween(thisWeek, yesterdayAtMidnight)) {
      notifsCategorizedByRelativeDate['This Week'].push(notif);
    } else if (date.isBetween(lastWeekAtMidnight, thisWeek)) {
      notifsCategorizedByRelativeDate['Last Week'].push(notif);
    } else if (date.isAfter(thisMonth)) {
      notifsCategorizedByRelativeDate['This Month'].push(notif);
    } else if (date.isBetween(lastMonth, thisMonth)) {
      notifsCategorizedByRelativeDate['Last Month'].push(notif);
    } else {
      const dateYearKey = date.format('MMMM YYYY');
      if (!(dateYearKey in notifsCategorizedByRelativeDate)) {
        notifsCategorizedByRelativeDate[dateYearKey] = [notif];
      } else {
        notifsCategorizedByRelativeDate[dateYearKey].push(notif);
      }
    }
  });

  const datesWithNotifs = Object.entries(
    notifsCategorizedByRelativeDate,
  ).reduce((acc: Record<string, any>, [key, value]) => {
    if (!value.length) return acc;
    acc[key] = value;
    return acc;
  }, {});

  return datesWithNotifs;
};

export default filterNotifsByDate;
